module.exports = (__webpack_require__(0))(7);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/constants.js from dll-reference girder_lib
// module id = 15
// module chunks = 0